// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__M7N4P","footer":"NavbarSimple_footer__4+RZo","link":"NavbarSimple_link__GSaQ1","linkIcon":"NavbarSimple_linkIcon__QsubE"};